// Simple className utility for Tailwind v4 (no external deps needed)
export function cn(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}